import {createAction as createGenericAction} from 'redux-actions'

const createAction = name =>
  createGenericAction(`HEALTH_VOLUME_MATRIX_TOOLTIP_${name}`)

export const show = createAction('SHOW')
export const hide = createAction('HIDE')
